import React from 'react';
import Grid from '@material-ui/core/Grid';
import Legend from 'components/RiskAnalysis/TypicalAssetAllocation/Legend/Legend';
import Charts from 'components/Charts';

const TypicalAssetAllocation = ({
  data,
  isAnimationActive = true,
  legend = null,
  isForReport = false,
  isForFactSheet = false
}: any) => {
  const LegendComponent = legend || Legend;

  return (
    <Grid container spacing={0} style={{ flex: 1 }}>
      <Grid
        item
        xs={12}
        style={{
          flex: 1,
          flexDirection: 'column',
          display: 'flex',
          padding: '0 1rem'
        }}
      >
        <Grid container style={{ flex: 1 }}>
          <Grid
            item
            xs={isForFactSheet ? 5 : 4}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginTop: '1rem'
            }}
          >
            <LegendComponent
              data={data}
              isForReport={isForReport}
              isForFactSheet={isForFactSheet}
            />
          </Grid>
          <Grid
            item
            xs={isForFactSheet ? 7 : 8}
            style={{
              marginTop: '1rem'
            }}
          >
            <Charts.RiskSummaary.TypicalAssetAllocation
              data={data}
              isAnimationActive={isAnimationActive}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TypicalAssetAllocation;
